export const SET_CARDS = "SET_CARDS";
export const SET_BUSINESS = "SET_BUSINESS";
export const SET_SLOTS = "SET_SLOTS";
